import { z } from "zod";
export const User = z.object({
    id: z.string(),
    email: z.email(),
});
//# sourceMappingURL=user.js.map